<template>
  <el-dialog
    :title="$t('housekeepingFeeType.addTitle')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="addHousekeepingFeeTypeInfo" label-width="120px">
      <el-form-item
        :label="$t('housekeepingFeeType.typeName')"
        prop="typeName"
        :rules="[
          { required: true, message: $t('housekeepingFeeType.typeNameRequired'), trigger: 'blur' },
          { max: 30, message: $t('housekeepingFeeType.typeNameMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="addHousekeepingFeeTypeInfo.typeName"
          :placeholder="$t('housekeepingFeeType.typeNamePlaceholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('housekeepingFeeType.isShow')"
        prop="isShow"
        :rules="[
          { required: true, message: $t('housekeepingFeeType.isShowRequired'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="addHousekeepingFeeTypeInfo.isShow"
          :placeholder="$t('housekeepingFeeType.isShowPlaceholder')"
          style="width:100%"
        >
          <el-option
            v-for="item in addHousekeepingFeeTypeInfo.isShows"
            :key="item.statusCd"
            :label="item.name"
            :value="item.statusCd"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('housekeepingFeeType.remark')">
        <el-input
          v-model="addHousekeepingFeeTypeInfo.remark"
          type="textarea"
          :placeholder="$t('housekeepingFeeType.remarkPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveHousekeepingFeeTypeInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { saveHousekeepingFeeType } from '@/api/housekeeping/housekeepingFeeTypeApi'

export default {
  name: 'AddHousekeepingFeeType',
  data() {
    return {
      dialogVisible: false,
      addHousekeepingFeeTypeInfo: {
        feeTypeCd: '',
        typeName: '',
        isShow: '',
        isShows: [],
        remark: '',
        shopId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._getDictData()
    },
    async _getDictData() {
      try {
        const {data} = await getDict('housekeeping_type', 'is_show')
        this.addHousekeepingFeeTypeInfo.isShows = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.addHousekeepingFeeTypeInfo = {
        feeTypeCd: '',
        typeName: '',
        isShow: '',
        isShows: [],
        remark: '',
        shopId: ''
      }
    },
    async saveHousekeepingFeeTypeInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        this.addHousekeepingFeeTypeInfo.shopId = getShopId()
        try {
          await saveHousekeepingFeeType(this.addHousekeepingFeeTypeInfo)
          this.$message.success(this.$t('common.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          this.$message.error(error)
          console.error('保存失败:', error)
        }
      })
    }
  }
}
</script>